import { j as t } from "./index.es33.js";
import n from "./index.es106.js";
import "./index.es133.js";
import "react";
import "react-dom";
import "./index.es134.js";
import { TimeZoneDate as e } from "./index.es506.js";
import "./index.es13.js";
import { TooltipShorten as a } from "./index.es14.js";
import "./index.es15.js";
import { weekIndexMap as o } from "./index.es668.js";
var k = [{
  key: "1",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterToday")
  }),
  handler: function handler() {
    return [new Date(new Date(new e().setHours(0, 0, 0, 0))), new Date(new Date(new e().setHours(23, 59, 0, 0)))];
  }
}, {
  key: "2",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterYesterday")
  }),
  handler: function handler() {
    return [new Date(new Date(new e().setHours(0, 0, 0, 0)).setDate(new e().getDate() - 1)), new Date(new Date(new e().setHours(23, 59, 0, 0)).setDate(new e().getDate() - 1))];
  }
}, {
  key: "3",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterThisWeek")
  }),
  handler: function handler() {
    return [new Date(new Date(new e().setHours(0, 0, 0, 0)).setDate(new e().getDate() - o[new e().getDay()])), new Date(new Date(new e().setHours(23, 59, 0, 0)))];
  }
}, {
  key: "4",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterLast7Days")
  }),
  handler: function handler() {
    return [new Date(new Date(new e().setHours(0, 0, 0, 0)).setDate(new e().getDate() - 6)), new Date(new e().setHours(23, 59))];
  }
}, {
  key: "5",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterLastWeek")
  }),
  handler: function handler() {
    return [new Date(new Date(new e().setHours(0, 0, 0, 0)).setDate(new e().getDate() - o[new e().getDay()] - 7)), new Date(new Date(new e().setHours(23, 59, 0, 0)).setDate(new e().getDate() + (6 - o[new e().getDay()]) - 7))];
  }
}, {
  key: "6",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterThisMonth")
  }),
  handler: function handler() {
    return [new Date(new Date(new e().setHours(0, 0, 0, 0)).setDate(1)), new Date(new e().setHours(23, 59))];
  }
}, {
  key: "7",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterLastMonth")
  }),
  handler: function handler() {
    return [new Date(new Date(new Date(new e().setMonth(new e().getMonth() - 1)).setHours(0, 0, 0, 0)).setDate(1)), new Date(new Date(new Date(new e().setDate(0))).setHours(23, 59))];
  }
}, {
  key: "8",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterLast30Days")
  }),
  handler: function handler() {
    return [new Date(new Date(new e().setHours(0, 0, 0, 0)).setDate(new e().getDate() - 29)), new Date(new e().setHours(23, 59))];
  }
}, {
  key: "9",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterThisYear")
  }),
  handler: function handler() {
    return [new Date(new Date(new Date(new e().setDate(1)).setMonth(0)).setHours(0, 0, 0, 0)), new Date(new e().setHours(23, 59, 0, 0))];
  }
}, {
  key: "10",
  label: t.jsx(a, {
    title: n.t("component_component_calendarPickerLabel_datesFilterLastYear")
  }),
  handler: function handler() {
    return [new Date(new e().setFullYear(new e().getFullYear() - 1, 0, 1)), new Date(new e().setFullYear(new e().getFullYear() - 1, 11, 31))];
  }
}];
export { k as periods };